import React, { Component } from "react";
import { connect } from "react-redux";
import LazyLoad from "react-lazyload";

import s from "./Gsecond.module.scss";
import { FormattedMessage } from "react-intl";

class Gsecond extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showAnimation: false
    };
    this._handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener("scroll", this._handleScroll);
    // 初始检查一次位置
    this._handleScroll();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this._handleScroll);
  }
  handleScroll() {
    const clientHeight = document.documentElement.clientHeight;
    const gsecondRect = this.refs.Gsecond.getBoundingClientRect();
    
    // 当元素的顶部进入视口60%时触发动画
    if (gsecondRect.top < clientHeight * 0.8 && !this.state.showAnimation) {
      this.setState({ showAnimation: true });
    }

    // 保留原有的图片动画效果
    if (clientHeight - 200 > gsecondRect.top && this.refs.img) {
      setTimeout(() => {
        this.refs.img.style.opacity = 1;
        this.refs.img.style.bottom = "30px";
      }, 500);
    }
  }
  render() {
    const { locale } = this.props;
    const { showAnimation } = this.state;
    
    return (
      <div ref="Gsecond">
        <LazyLoad height={400}>
          <div className={locale.indexOf('US') > -1 ? s.GsecondEn : s.Gsecond}>
            <div className={s.wrap}>
              <div className={s.text} ref="text">
                <div className={`${s.title} ${showAnimation ? s.animateIn : s.hidden}`}>
                  <FormattedMessage
                    id="gs3_second_title"
                    values={{ br: <br /> }}
                  />
                </div>
                <div className={`${s.desc} ${showAnimation ? s.animateIn : s.hidden}`}>
                  <FormattedMessage
                    id="gs3_second_desc"
                    values={{ br: <br /> }}
                  />
                </div>
              </div>
              <div
                className={
                  locale.indexOf("US") > -1
                    ? s.img_en
                    : locale.indexOf("TW") > -1
                    ? s.img_tw
                    : s.img
                }
                ref="img"
              />
            </div>
          </div>
        </LazyLoad>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.language,
});

const GSecond = connect(mapStateToProps)(Gsecond);

export default GSecond;
